import { notification } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export default function ZenifyErrorNotify() {
  const errors = useSelector(state => state.notification.errors);
  const lastShownId = useRef(null);

  useEffect(() => {
    if (!errors.length) return;

    const latest = errors[0];
    // tránh show lại cùng 1 lỗi
    if (latest.id === lastShownId.current) return;
    lastShownId.current = latest.id;
    notification.error({
      message: latest.title,
      description: latest.message,
      icon: <WarningOutlined style={{ color: "#ff4d4f" }} />,
      placement: "topRight",
      duration: 7,
    });

  }, [errors]);

  return null;
}
